import { Component, OnInit, trigger, transition, animate, style, state, ApplicationRef } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Toast, ToastData, ToastrService, ToastRef } from 'ngx-toastr';
import { CfAlertsService } from '../../services/alerts-service/alerts.service';
/**
 * It is private component for <b>cf-alerts</b>
 */
export class CfAlertComponent extends Toast implements OnInit {
  options: any;
/**
 * @hidden
 * @param {?} toastrService
 * @param {?} data
 * @param {?} toastRef
 * @param {?} appRef
 * @param {?} sanitizer
 * @param {?} alertsService
 */
constructor(
    /**@hidden */ protected toastrService: ToastrService,
public data: ToastData,
    /**@hidden */ protected toastRef: ToastRef<any>,
    /**@hidden */ protected appRef: ApplicationRef,
    /**@hidden */ protected sanitizer: DomSanitizer,
public alertsService: CfAlertsService
  ) {
    super(toastrService, data, toastRef, appRef, sanitizer);
  }
/**
 * @hidden 
 * It is function called by user on alert inform icon click to emit event by alerts service
 * @param {?} id  alert unique ID
 * @return {?}
 */
inform(id) {
    this.alertsService.alertInfoEvent(id);
    this.remove();
  }
/**
 * @hidden 
 * It is function called by user on alert confirm icon click to emit event by alerts service
 * @param {?} id  alert unique ID
 * @return {?}
 */
confirm(id) {
    this.alertsService.alertOkEvent(id);
    this.remove();
  }
/**
 * @hidden 
 * It is function called by user on alert cancel icon click to emit event by alerts service
 * @param {?} id  alert unique ID
 * @return {?}
 */
cancel(id) {
    this.alertsService.alertCancelEvent(id);
    this.remove();
  }
/**
 * @hidden
 * @return {?}
 */
ngOnInit() {
    // console.log('ALERT', this);
  }
/**
 * @hidden 
 * Function to set type of alert: info, warning, error
 * @return {?}
 */
getAlertType() {
    let /** @type {?} */ type = 'mat-primary';
    if (this.options && this.options['type'] !== '') {
      if (this.options['type'] === 'warning') { type = 'mat-accent'; }
      if (this.options['type'] === 'error') { type = 'mat-warn'; }
    }
    return type;
  }
/**
 * @param {?} element
 * @return {?}
 */
getDynamicClasses(element) {
    if (element != null) {
      try {
        let /** @type {?} */ classes = '', /** @type {?} */ mainKeys = Object.keys(element);
        for (let /** @type {?} */ key of mainKeys) {
          // tslint:disable-next-line:no-eval
          if (eval(element[key]) === true) { classes = classes + ' ' + key; }
          // if (new Function('_', 'return _.' + element[key])(this) === true) { classes = classes + ' ' + key; }
        }
        return classes;
      } catch ( /** @type {?} */e) {
        // Do nothing
      }
    }
  }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'cf-alert',
  template: "<div *ngIf=\"options?.display\" class=\"cf-alert-container {{options?.styling?.container?.class}}\" [ngClass]=\"getDynamicClasses(options?.styling?.container?.dynamicClass)\"> <md-toolbar class=\"cf-alert-toolbar mat-toolbar {{getAlertType()}} {{options?.styling?.toolbar?.class}}\" [ngClass]=\"getDynamicClasses(options?.styling?.toolbar?.dynamicClass)\"> <div class=\"cf-alert-inform-icon {{options?.styling?.toolbar?.inform?.class}}\" *ngIf=\"options?.inform?.show\" [ngClass]=\"getDynamicClasses(options?.styling?.toolbar?.inform?.dynamicClass)\"> <cf-icon [properties]=\"options?.inform?.icon\" [styling]=\"options?.styling?.toolbar?.inform?.icon\" (click)=\"inform(options?.id)\"></cf-icon> </div> <div class=\"cf-alert-content {{options?.styling?.toolbar?.content?.class}}\" [ngClass]=\"getDynamicClasses(options?.styling?.toolbar?.content?.dynamicClass)\"> <div class=\"cf-alert-title {{options?.styling?.toolbar?.content?.title?.class}}\" [ngClass]=\"getDynamicClasses(options?.styling?.toolbar?.content?.title?.dynamicClass)\">{{options?.content?.title}}</div> <div class=\"cf-alert-message {{options?.styling?.toolbar?.content?.message?.class}}\" [ngClass]=\"getDynamicClasses(options?.styling?.toolbar?.content?.message?.dynamicClass)\">{{options?.content?.message}}</div> <div class=\"cf-alert-template {{options?.styling?.toolbar?.content?.template?.class}}\" [ngClass]=\"getDynamicClasses(options?.styling?.toolbar?.content?.template?.dynamicClass)\"> <span [ngTemplateOutlet]=\"options?.templateRef\"></span> </div> </div> <div class=\"cf-alert-confirm-icon {{options?.styling?.toolbar?.confirm?.class}}\" *ngIf=\"options?.confirm?.show\" [ngClass]=\"getDynamicClasses(options?.styling?.toolbar?.confirm?.dynamicClass)\"> <cf-icon [properties]=\"options?.confirm?.icon\" [styling]=\"options?.styling?.toolbar?.confirm?.icon\" (click)=\"confirm(options?.id)\"></cf-icon> </div> <div class=\"cf-alert-cancel-icon {{options?.styling?.toolbar?.cancel?.class}}\" *ngIf=\"options?.cancel?.show\" [ngClass]=\"getDynamicClasses(options?.styling?.toolbar?.cancel?.dynamicClass)\"> <cf-icon [properties]=\"options?.cancel?.icon\" [styling]=\"options?.styling?.toolbar?.cancel?.icon\" (click)=\"cancel(options?.id)\"></cf-icon> </div> </md-toolbar> <div *ngIf=\"options?.progressBar\" class=\"cf-alert-progress-bar {{options?.styling?.progressBar?.class}}\" [ngClass]=\"getDynamicClasses(options?.styling?.progressBar?.dynamicClass)\" [style.width.%]=\"width\"></div> </div>",
  styles: [":host /deep/ { position: relative; display: flex; flex-direction: column; width: auto; max-width: 568px; min-width: 288px; margin: 0 8px; border-radius: 2px; box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 1px 18px 0 rgba(0, 0, 0, 0.12); overflow: hidden; pointer-events: all; } :host /deep/ > div > md-toolbar.mat-toolbar { min-height: 48px; padding: 0 12px; font-size: 16px; justify-content: center; } :host /deep/ > div > md-toolbar.mat-toolbar > div > .mat-toolbar-row { height: auto; justify-content: space-between; } :host /deep/ > div > md-toolbar.mat-toolbar > div > .mat-toolbar-row > cf-icon { margin: 0 2px; } :host /deep/ > div > md-toolbar.mat-toolbar > div > .mat-toolbar-row md-icon { color: currentColor; } :host /deep/ .cf-alert-inform-icon, :host /deep/ .cf-alert-content, :host /deep/ .cf-alert-confirm-icon, :host /deep/ .cf-alert-cancel-icon { display: flex; flex-direction: column; padding: 0px 4px; } :host /deep/ .cf-alert-content { flex-grow: 1; } :host /deep/ .cf-alert-progress-bar { position: absolute; left: 0; bottom: 0; height: 4px; background-color: #000000; opacity: 0.4; } "],
  animations: [
    trigger('flyInOut', [
      state('inactive', style({ display: 'none', opacity: 0 })),
      state('active', style({ opacity: 1 })),
      state('removed', style({ opacity: 0 })),
      transition('inactive => active', animate('300ms ease-in')),
      transition('active => removed', animate('300ms ease-in')),
    ])
  ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ToastrService, },
{type: ToastData, },
{type: ToastRef, },
{type: ApplicationRef, },
{type: DomSanitizer, },
{type: CfAlertsService, },
];
}

function CfAlertComponent_tsickle_Closure_declarations() {
/** @type {?} */
CfAlertComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CfAlertComponent.ctorParameters;
/** @type {?} */
CfAlertComponent.prototype.options;
/**
 * @hidden
 * @type {?}
 */
CfAlertComponent.prototype.toastrService;
/**
 * @hidden
 * @type {?}
 */
CfAlertComponent.prototype.data;
/**
 * @hidden
 * @type {?}
 */
CfAlertComponent.prototype.toastRef;
/**
 * @hidden
 * @type {?}
 */
CfAlertComponent.prototype.appRef;
/**
 * @hidden
 * @type {?}
 */
CfAlertComponent.prototype.sanitizer;
/**
 * @hidden
 * @type {?}
 */
CfAlertComponent.prototype.alertsService;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
